import { render, staticRenderFns } from "./EzWorkingHours.vue?vue&type=template&id=54c33df8&scoped=true&"
import script from "./EzWorkingHours.vue?vue&type=script&lang=js&"
export * from "./EzWorkingHours.vue?vue&type=script&lang=js&"
import style0 from "./EzWorkingHours.vue?vue&type=style&index=0&id=54c33df8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c33df8",
  null
  
)

export default component.exports